'use client';

// Utils
import { c as _c } from "react/compiler-runtime";
import { useToggle } from '@hooks';
import { appendUrlParams } from '@utils/append-url-params';

// UI
import { Icon, IconNames } from '@components/icon';
import { PhoneNumberModal } from '../header/phone-number-modal';
import { AnalyticsRef } from '@components/analytics-ref';
export enum SocialSectionType {
  Account = 'account',
  Listing = 'listing',
}
type Props = {
  contacts: {
    bookDirectWebsiteUrl?: string;
    facebookPageUrl?: string;
    instagramUrl?: string;
    youtubeUrl?: string;
    twitterUrl?: string;
    pinterestUrl?: string;
    marketingWebsiteUrl?: string;
    publicPhoneNumber?: string;
    publicEmail?: string;
    linkedinUrl?: string;
  };
  shouldShowSocialMedia?: boolean;
  shouldShowWebsiteUrlAsButton: string | boolean | undefined;
  type?: SocialSectionType;
};
export const SocialSection: React.FC<Props> = t0 => {
  const $ = _c(47);
  const {
    contacts,
    shouldShowSocialMedia: t1,
    shouldShowWebsiteUrlAsButton,
    type: t2
  } = t0;
  const shouldShowSocialMedia = t1 === undefined ? true : t1;
  const type = t2 === undefined ? SocialSectionType.Listing : t2;
  const {
    on: phoneNumberModalIsOpen,
    setOff: closePhoneNumberModal,
    setOn: openPhoneNumberModal
  } = useToggle();
  if (!contacts.facebookPageUrl && !contacts.instagramUrl && !contacts.youtubeUrl && !contacts.marketingWebsiteUrl && !contacts.publicPhoneNumber && !contacts.publicEmail && !contacts.pinterestUrl && !contacts.linkedinUrl) {
    return null;
  }
  let t3;
  if ($[0] !== contacts.marketingWebsiteUrl || $[1] !== shouldShowWebsiteUrlAsButton || $[2] !== type) {
    t3 = !shouldShowWebsiteUrlAsButton && contacts.marketingWebsiteUrl && <AnalyticsRef name={`select_${type}_website`}><a href={appendUrlParams(contacts.marketingWebsiteUrl, {
        utm_source: "Savvy",
        utm_medium: "website"
      })} target="_blank" rel="noreferrer"><Icon size="lg" name={IconNames.BROWSER} className="w-7 h-7 hover:opacity-80" /></a></AnalyticsRef>;
    $[0] = contacts.marketingWebsiteUrl;
    $[1] = shouldShowWebsiteUrlAsButton;
    $[2] = type;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== closePhoneNumberModal || $[5] !== contacts.publicPhoneNumber || $[6] !== openPhoneNumberModal || $[7] !== phoneNumberModalIsOpen || $[8] !== type) {
    t4 = contacts.publicPhoneNumber && <div><PhoneNumberModal isOpen={phoneNumberModalIsOpen} closeModal={closePhoneNumberModal} phoneNumber={contacts.publicPhoneNumber} /><AnalyticsRef name={`select_${type}_phone`}><button type="button" aria-label="Show phone number" className="outline-none focus-visible:ring-2 focus-visible:ring-primary-main" onClick={openPhoneNumberModal}><Icon size="lg" name={IconNames.PHONE} className="w-7 h-7 hover:opacity-80" /></button></AnalyticsRef></div>;
    $[4] = closePhoneNumberModal;
    $[5] = contacts.publicPhoneNumber;
    $[6] = openPhoneNumberModal;
    $[7] = phoneNumberModalIsOpen;
    $[8] = type;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== contacts.publicEmail || $[11] !== type) {
    t5 = contacts.publicEmail && <AnalyticsRef name={`select_${type}_email`}><a href={`mailto:${contacts.publicEmail}?subject=Inquiry from Savvy`}><Icon size="lg" name={IconNames.ENVELOPE} className="w-7 h-7 hover:opacity-80" /></a></AnalyticsRef>;
    $[10] = contacts.publicEmail;
    $[11] = type;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== contacts.facebookPageUrl || $[14] !== shouldShowSocialMedia || $[15] !== type) {
    t6 = contacts.facebookPageUrl && shouldShowSocialMedia && <AnalyticsRef name={`select_${type}_social`}><a href={contacts.facebookPageUrl} target="_blank" rel="noopener noreferrer"><Icon size="lg" name={IconNames.FACEBOOK} className="w-7 h-7 hover:opacity-80" /></a></AnalyticsRef>;
    $[13] = contacts.facebookPageUrl;
    $[14] = shouldShowSocialMedia;
    $[15] = type;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== contacts.instagramUrl || $[18] !== shouldShowSocialMedia || $[19] !== type) {
    t7 = contacts.instagramUrl && shouldShowSocialMedia && <AnalyticsRef name={`select_${type}_social`}><a href={contacts.instagramUrl} target="_blank" rel="noopener noreferrer"><Icon size="lg" name={IconNames.INSTAGRAM} className="w-7 h-7 hover:opacity-80" /></a></AnalyticsRef>;
    $[17] = contacts.instagramUrl;
    $[18] = shouldShowSocialMedia;
    $[19] = type;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== contacts.youtubeUrl || $[22] !== shouldShowSocialMedia || $[23] !== type) {
    t8 = contacts.youtubeUrl && shouldShowSocialMedia && <AnalyticsRef name={`select_${type}_social`}><a href={contacts.youtubeUrl} target="_blank" rel="noopener noreferrer"><Icon size="lg" name={IconNames.YOUTUBE} className="w-7 h-7 hover:opacity-80" /></a></AnalyticsRef>;
    $[21] = contacts.youtubeUrl;
    $[22] = shouldShowSocialMedia;
    $[23] = type;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== contacts.twitterUrl || $[26] !== shouldShowSocialMedia || $[27] !== type) {
    t9 = contacts.twitterUrl && shouldShowSocialMedia && <AnalyticsRef name={`select_${type}_social`}><a href={contacts.twitterUrl} target="_blank" rel="noopener noreferrer"><Icon size="lg" name={IconNames.TWITTERX} className="w-7 h-7 hover:opacity-80" /></a></AnalyticsRef>;
    $[25] = contacts.twitterUrl;
    $[26] = shouldShowSocialMedia;
    $[27] = type;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== contacts.pinterestUrl || $[30] !== shouldShowSocialMedia || $[31] !== type) {
    t10 = contacts.pinterestUrl && shouldShowSocialMedia && <AnalyticsRef name={`select_${type}_social`}><a href={contacts.pinterestUrl} target="_blank" rel="noopener noreferrer"><Icon size="lg" name={IconNames.PINTEREST} className="w-7 h-7 hover:opacity-80" /></a></AnalyticsRef>;
    $[29] = contacts.pinterestUrl;
    $[30] = shouldShowSocialMedia;
    $[31] = type;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] !== contacts.linkedinUrl || $[34] !== shouldShowSocialMedia || $[35] !== type) {
    t11 = contacts.linkedinUrl && shouldShowSocialMedia && <AnalyticsRef name={`select_${type}_social`}><a href={contacts.linkedinUrl} target="_blank" rel="noopener noreferrer"><Icon size="lg" name={IconNames.LINKEDIN} className="w-7 h-7 hover:opacity-80" /></a></AnalyticsRef>;
    $[33] = contacts.linkedinUrl;
    $[34] = shouldShowSocialMedia;
    $[35] = type;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  let t12;
  if ($[37] !== t10 || $[38] !== t11 || $[39] !== t3 || $[40] !== t4 || $[41] !== t5 || $[42] !== t6 || $[43] !== t7 || $[44] !== t8 || $[45] !== t9) {
    t12 = <div><div className="flex overflow-x-auto w-full justify-start items-center text-primary-main space-x-4">{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}</div></div>;
    $[37] = t10;
    $[38] = t11;
    $[39] = t3;
    $[40] = t4;
    $[41] = t5;
    $[42] = t6;
    $[43] = t7;
    $[44] = t8;
    $[45] = t9;
    $[46] = t12;
  } else {
    t12 = $[46];
  }
  return t12;
};